//Set the position of the € symbol
// If it is in this enum the symbol will be positioned before the number
export enum LanguageCurrencyEnum {
    nl = 'nl',
    en = 'en'
}